<template>
  <div>
    <template v-if="$route.name == 'rolemanagement'">
      <!-- 角色管理标题 -->
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
      <!-- 角色管理搜索框 -->
      <ots-refer
        :selectList="selectList"
        :request-form="selectForm"
        @search="search"
      />
      <!-- table 表格 -->
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableOption="tableOption"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
      <!-- 新增用户/编辑用户 弹窗 -->
      <ots-custom-dialog
        :dialog.sync="downDialog"
        :title="isaddrule ? '添加角色' : '编辑角色'"
        width="40%"
      >
        <template v-slot:content>
          <div class="exportDialog">
            <el-form :model="addRuleForm" ref="addRuleForm" :rules="addRules">
              <el-form-item label="角色名称" prop="name">
                <el-input
                  v-model.trim="addRuleForm.name"
                  placeholder="请输入"
                  
                  >></el-input
                >
              </el-form-item>
              <el-form-item label="权限类别" prop="typeId">
                <el-radio-group
                  v-model="addRuleForm.typeId"
                  :disabled="isaddrule ? false : true"
                >
                  <el-radio-button label="2">院校权限</el-radio-button>
                  <el-radio-button label="3">教学点权限</el-radio-button>
                  <el-radio-button label="6">巡考教师权限</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="角色描述" prop="desc">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入"
                  v-model="addRuleForm.desc"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="downDialog = false">取消</el-button>
          <el-button round type="primary" @click="addRole('addRuleForm')"
            >确定</el-button
          >
        </template>
      </ots-custom-dialog>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
// 角色管理列表, 获取角色授权数据
import {
  queryRoleList,
  submitRoleSet,
  deleteRoleSet,
} from "@/http/modules/user.js";
export default {
  name: "roleManagement",
  data() {
    return {
      istype: true,
      /* ***** 是否开启新增角色弹窗 ***** */
      downDialog: false,
      /* ***** 角色管理标题 ***** */
      mainTopBtnList: [
        {
          title: "新增",
          fn: this.addRoleBtn,
        },
      ],
      /* ***** 新增/编辑 用户表单 ***** */
      isaddrule: true,
      addRuleForm: {
        id: "",
        name: "",
        typeId: "",
        desc: "",
      },
      addRules: {
        name: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { max: 50, message: "最多可输入50个字!", trigger: "blur" },
          { validator: this.isRepeatRole, trigger: "blur" },
        ],
        typeId: [
          { required: true, message: "请选择角色权限", trigger: "blur" },
        ],
        desc: [{ max: 100, message: "最多可输入100个字!", trigger: "blur" }],
      },
      /* ***** 搜索 ***** */
      selectList: [
        {
          title: "角色名称",
          type: "input",
          requestKey: "name",
          placeholder: "请输入",
        },
        {
          title: "权限类别",
          type: "select",
          requestKey: "typeId",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "院校权限",
              value: "2",
            },
            {
              key: "教学点权限",
              value: "3",
            },
            {
              key: "巡考教师权限",
              value: "6",
            },
          ],
        },
      ],
      /* ***** 表单值 ***** */
      selectForm: {
        name: "",
        page: 1,
        size: 10,
        orders: "",
        typeId: "",
      },
      /* ***** 表格数据 ***** */
      tableData: [],
      /* ***** 分页 ***** */
      pagination: {
        total: 0,
      },
      tableOption: {},
      /* ***** 表格头 ***** */
      tableHeader: [
        {
          title: "角色名称",
          prop: "roleName",
          fixed: "left",
        },
        {
          title: "权限类别",
          prop: "typeName",
          fixed: "left",
        },
        {
          title: "角色描述",
          prop: "desc",
          fixed: "left",
        },
        {
          title: "已添加用户数",
          type: "button",
          disableFn: (val) => (val.row.count ? false : true),
          prop: "count",
          fixed: "left",
          click: this.selectUserDetails,
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: (scope) => {
                return "授权";
              },
              click: this.getRoleType,
            },
            {
              title: (scope) => {
                return "添加用户";
              },
              click: this.selectUserDetailsNot,
            },
            {
              title: (scope) => {
                return "编辑";
              },
              click: this.revRoleBtn,
            },
            {
              title: (scope) => {
                return "删除";
              },
              formatter: (scope) => {
                return !scope.row.count == 0;
              },
              click: this.deleteRole,
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.getResult();
  },
  methods: {
    /****************************
     * @this 获取角色管理列表***table***
     ***************************/
     search() {
      this.selectForm.page = 1;
      this.getResult();
    },
    getResult() {
      queryRoleList(this.selectForm).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        }
      });
    },

    /****************************
     * @this 查询用户(已添加)(进入二级页面)
     ***************************/
    selectUserDetails(row) {
      if (row.count) {
        this.$router.push({
          name: "addUser",
          query: {
            id: row.id,
            roleType: row.roleType,
            isAdd: true,
          },
        });
      } else {
        return false;
      }
    },

    /****************************
     * @this 查询用户(未添加)(进入二级页面)
     ***************************/
    selectUserDetailsNot(row) {
      this.$router.push({
        name: "addUser",
        query: {
          id: row.id,
          roleType: row.roleType,
          isAdd: false,
        },
      });
    },

    /****************************
     * @this 新增角色按钮
     ***************************/
    addRoleBtn() {
      this.downDialog = true;
      this.addRuleForm.id = "";
      this.addRuleForm.name = "";
      this.addRuleForm.desc = "";
      this.isaddrule = true;
    },

    /****************************
     * @this 角色编辑按钮,设置默认表单
     ***************************/
    revRoleBtn(row) {
      this.downDialog = true;
      this.addRuleForm.id = row.id;
      this.addRuleForm.name = row.roleName;
      if (row.roleType === 3) {
        this.addRuleForm.typeId = 6;
      } else {
        this.addRuleForm.typeId = row.roleType + 1;
      }

      this.addRuleForm.desc = row.desc;
      this.isaddrule = false;
    },

    /****************************
     * @this 判断新增/编辑角色名是否重复
     ***************************/
    isRepeatRole(rule, value, callback) {
      if (!this.addRuleForm.id) {
        this.tableData.forEach((e) => {
          if (this.addRuleForm.name == e.roleName) {
            callback(new Error("角色名称重复！"));
          }
        });
        callback();
      } else {
        this.tableData.forEach((e) => {
          if (this.addRuleForm.name == e.roleName) {
            if (e.id == this.addRuleForm.id) {
              callback();
            } else {
              callback(new Error("角色名称重复！"));
            }
          }
        });
        callback();
      }
    },

    /****************************
     * @this 新增/编辑角色表单提交
     ***************************/
    addRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submitRoleSet(this.addRuleForm).then((res) => {
            if (res.code == 1) {
              this.getResult();
              this.$message.success("操作成功！");
            }
          });
          this.downDialog = false;
        } else {
          console.log("Error Submit");
          return false;
        }
      });
    },

    /****************************
     * @this 角色删除(确认删除提示)
     ***************************/
    deleteRole(row) {
      let roleId = row.id;
      this.$confirm("确定要删除这个角色？", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteRoleSet({ roleId }).then((res) => {
            if (res.code == 1) {
              this.getResult();
              this.$message.success("操作成功");
            }
          });
        })
        .catch(() => {});
    },

    /****************************
     * @this 授权
     ***************************/
    getRoleType(row) {
      this.$router.push({
        name: "getRoleType",
        query: {
          roleId: row.id,
          roleType: row.roleType,
        },
      });
    },

    /****************************
     * @this 分页相关
     ***************************/
    changeSize(num) {
      this.selectForm.size = num;
      this.getResult();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getResult();
    },
  },
};
</script>

<style>
</style>